var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0251 0.532034C12.9821 0.429658 12.9097 0.342311 12.8171 0.280999C12.7245 0.219688 12.6158 0.187155 12.5048 0.187503H1.25478C1.14373 0.187155 1.03506 0.219688 0.942465 0.280999C0.849872 0.342311 0.777499 0.429658 0.734467 0.532034C0.693941 0.635934 0.68366 0.749184 0.704814 0.858683C0.725967 0.968182 0.77769 1.06945 0.853998 1.15078L6.479 6.77578C6.58651 6.87975 6.73022 6.93786 6.87978 6.93786C7.02934 6.93786 7.17304 6.87975 7.28056 6.77578L12.9056 1.15078C12.9819 1.06945 13.0336 0.968182 13.0547 0.858683C13.0759 0.749184 13.0656 0.635934 13.0251 0.532034Z",
    fill: "#7B7B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRightIcon);
export default __webpack_public_path__ + "static/media/menu-right-icon.aa1a648d2d99380e202ee9745ec531b6.svg";
export { ForwardRef as ReactComponent };